<script setup>
import { computed, inject } from 'vue';

const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  count: {
    type: Number,
    default: 0,
  },
  showBadge: {
    type: Boolean,
    default: true,
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
});

const activeIndex = inject('activeIndex');
const updateActiveIndex = inject('updateActiveIndex');

const active = computed(() => props.index === activeIndex.value);
const getItemCount = computed(() => props.count);

const onTabClick = event => {
  event.preventDefault();
  if (!props.disabled) {
    updateActiveIndex(props.index);
  }
};
</script>

<template>
  <li
    class="flex-shrink-0 my-0 hover:text-n-slate-12"
    :class="
      isCompact
        ? 'mx-0.5'
        : 'mx-2 ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0'
    "
  >
    <a
      class="flex items-center flex-row select-none cursor-pointer relative text-button"
      role="tab"
      tabindex="0"
      :aria-selected="active"
      :class="[
        isCompact
          ? ['sd-tab', { 'sd-tab--active': active }]
          : [
              'after:absolute after:bottom-px after:left-0 after:right-0 after:h-[2px] after:rounded-full after:transition-all after:duration-200 !text-base py-3',
              active
                ? 'text-n-blue-11 after:bg-n-brand after:opacity-100'
                : 'text-n-slate-11 after:bg-transparent after:opacity-0',
            ],
      ]"
      @click="onTabClick"
      @keydown.enter="onTabClick"
    >
      {{ name }}
      <div
        v-if="showBadge"
        class="sd-tab__count rounded-full h-[18px] flex items-center justify-center text-xxs font-semibold my-0 ltr:ml-1.5 rtl:mr-1.5 px-1.5 py-0 min-w-[18px]"
        :class="[
          active
            ? 'bg-n-blue-4 text-n-blue-11'
            : 'bg-n-alpha-2 text-n-slate-10',
        ]"
      >
        <span>
          {{ getItemCount }}
        </span>
      </div>
    </a>
  </li>
</template>
